import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {DestinationCard as DestinationCardBase} from '@homeaway/react-card-types';
import {
    CAROUSEL_DATA_FIELDS,
    CAROUSEL_TYPES,
    EVENT_TYPES,
} from '../../../../utils/edap/edapEventsConstants';
import useEdapEvent from '../../../../hooks/useEdapEvent';
import useEdapEventLegacy from '../../../../hooks/useEdapEventLegacy';

export default function DestinationCard(props) {
    const edapEvents = useEdapEvent(CAROUSEL_TYPES.DESTINATION);
    const {destinationCardClickEvent} = useEdapEventLegacy();
    const {
        aspectRatio,
        cardIndex,
        classNames,
        clientRequestId,
        place,
        imageHref,
        destinationUrl,
        searchTermUuid,
        cardLinkTarget,
        target,
        customCardClickHandler,
    } = props;

    const {
        name: {simple: simpleDestinationName},
    } = place;

    const classnames = cx(classNames, {
        'recommended-hit__destination': true,
    });

    const clickHandler = (e) => {
        customCardClickHandler(e, cardIndex);
        edapEvents[EVENT_TYPES.SELECTED]({
            clientRequestId,
            cardIndex,
            target,
            [CAROUSEL_DATA_FIELDS.CAROUSEL_CHILD]: searchTermUuid,
        });
        destinationCardClickEvent({
            actionlocation: 'recommended-destinations-component',
            eventlbsuuid: searchTermUuid,
            eventrefinements: `position:${cardIndex + 1}`,
        });
    };

    return (
        <div className={classnames} onClick={clickHandler}>
            <DestinationCardBase
                alt={simpleDestinationName}
                aspectRatio={aspectRatio}
                title={simpleDestinationName}
                imageUri={imageHref}
                clickUrl={destinationUrl}
                loadImage
                target={cardLinkTarget}
            />
        </div>
    );
}

DestinationCard.propTypes = {
    destinationUrl: PropTypes.string,
    imageHref: PropTypes.string,
    searchTermUuid: PropTypes.string,
    target: PropTypes.string,
    cardLinkTarget: PropTypes.string,
    customCardClickHandler: PropTypes.func,
    place: PropTypes.shape({
        name: PropTypes.shape({
            simple: PropTypes.string,
            full: PropTypes.string,
        }),
    }),
};
